import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect, NavLink } from "react-router-dom";
import { authUser, gotoSignIn } from '../../actions/auth_actions';
import downloadFile from '../../helpers/download-file';
import getFileName from '../../helpers/get-file-name';
import { withStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center'
  },
  loadingMessage: {
    fontSize: '2em',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: theme.palette.tertiary.main,
    textAlign: 'center'
  },
  loadingMessageError: {
    fontSize: '2em',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: theme.palette.secondary.dark,
    textAlign: 'center'
  },
  downloadNav: {
    marginTop: theme.spacing(1)
  },
  item: {
    textDecoration: "none",
    marginRight: 5
  },
  itemLink: {
    transition: "all 300ms linear",
    borderRadius: "3px",
    position: "relative",
    backgroundColor: "transparent",
    fontSize: "0.775rem",
    paddingRight: 8,
    paddingLeft: 8,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: 'white'
    },
    ".active &": {
      backgroundColor: theme.palette.primary.main,
      color: 'white'
    }
  }
});

class PrivateRoute extends Component {
  constructor(props) {
    super(props);

    const query = new URLSearchParams(location.search);
    const referrer = query.get('referrer');
    const fileName = getFileName(referrer);

    this.state = {
      token: localStorage.getItem('JWT') || sessionStorage.getItem('JWT'),
      referrer,
      fileName,
      downloadFinished: false,
      downloadError: false,
    };
  }

  downloadFile(referrer) {
    downloadFile(referrer)
      .then(() => this.setState({ downloadFinished: true }))
      .catch(error => this.setState({ downloadError: error.response.statusText }));
  }

  componentDidMount() {
    const { isLoggedIn } = this.props;
    const { referrer } = this.state;

    this.props.authUser(this.state.token);

    if (isLoggedIn && referrer) {
      this.downloadFile(referrer);
    }
  }

  componentDidUpdate({ isLoggedIn: prevIsLoggedIn }) {
    const { isLoggedIn, location: { pathname } } = this.props;
    const { referrer } = this.state;

    if (isLoggedIn !== prevIsLoggedIn && isLoggedIn && referrer) {
      this.downloadFile(referrer);
    }

    if (prevIsLoggedIn !== isLoggedIn && !isLoggedIn) {
      gotoSignIn(pathname);
    }
  }

  render() {
    const { component: Component, isLoggedIn, isLoading, classes, ...rest } = this.props;
    const { referrer, fileName, downloadFinished, downloadError } = this.state;
    return (
      isLoading && !isLoggedIn ?
        <div className={classes.loadingWrapper}>
          <span className={classes.loadingMessage}>Loading...</span>
        </div> :
        (<Route
          {...rest}
          render={props =>
            isLoggedIn ? (
              referrer ? (
                downloadFinished ? (
                  <div className={classes.loadingWrapper}>
                    <div className={classes.loadingMessage}>Downloaded<br/>{fileName}</div>
                    <div className={classes.downloadNav}>
                      <NavLink
                        to={'/dashboard'}
                        className={classes.item}
                      >
                        <Button
                          className={classes.itemLink}
                          variant="outlined"
                          color="primary"
                        >
                          Go to Dashboard
                        </Button>
                      </NavLink> or close this window
                    </div>
                  </div>
                ) : (
                  downloadError ? (
                    <div className={classes.loadingWrapper}>
                      <div className={classes.loadingMessageError}>
                        Download error&nbsp;: {downloadError}<br/>{fileName}
                      </div>
                      <div className={classes.downloadNav}>
                        <NavLink
                          to={'/dashboard'}
                          className={classes.item}
                        >
                          <Button
                            className={classes.itemLink}
                            variant="outlined"
                            color="primary"
                          >
                            Go to Dashboard
                          </Button>
                        </NavLink> or close this window
                      </div>
                    </div>
                  ) : (
                    <div className={classes.loadingWrapper}>
                    <span className={classes.loadingMessage}>
                      Downloading
                      <CircularProgress
                        disableShrink
                        size={20}
                        style={{ marginLeft: 20 }}
                      />
                    <br/>{fileName}</span>
                    </div>
                  )
                )
              ) : (
                <Component {...props} />
              )
            ) : (
              <Redirect
                to={{
                  pathname: `/sign-in`,
                  state: {
                    from: props.location,
                    referrer
                  }
                }}
              />
            )
          }
        />)
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isLoggedIn: state.auth.isLoggedIn,
  isLoading: state.auth.isLoading
});

export default withStyles(styles)(connect(
  mapStateToProps,
  { authUser }
  )(PrivateRoute)
);


// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.js